var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAIColorGeneration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.96143 12.543C8.83642 11.5271 10.1701 9.84989 11.2415 5.2629C12.3583 9.96463 13.6693 11.4645 18.5216 12.543C13.7058 13.6618 12.1055 15.2716 11.2415 19.823C10.0191 15.1363 8.48023 13.5775 3.96143 12.543Z",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8333 2.83398V4.16732M14.5 6.16732H15.8333M19.8333 6.16732H21.1667M17.8333 8.16732V9.50065",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAIColorGeneration);
export default __webpack_public_path__ + "static/media/aIColorGeneration.451c75a0345ceef6313d4bd3d826e807.svg";
export { ForwardRef as ReactComponent };